import type { TranslationMessages } from '../types';

export const product_categories: TranslationMessages = {
        title: 'Danh mục sản phẩm',
        subtitle: 'Quản lý danh mục sản phẩm để tổ chức sản phẩm của bạn',
        loading: 'Đang tải danh mục sản phẩm...',
        new_category: 'Danh mục mới',
        search_placeholder: 'Tìm kiếm danh mục...',
        no_categories:
          'Chưa có danh mục sản phẩm nào. Tạo danh mục đầu tiên của bạn!',
        no_results: 'Không tìm thấy danh mục nào phù hợp với tìm kiếm của bạn.',
        load_error: 'Không thể tải danh mục sản phẩm',
        delete_confirm: 'Bạn có chắc chắn muốn xóa danh mục này không?',
        delete_error: 'Không thể xóa danh mục. Vui lòng thử lại.',
        category_details: 'Chi tiết danh mục',
        name_placeholder: 'Nhập tên danh mục...',
        edit_subtitle: 'Cập nhật thông tin danh mục',
        create_subtitle: 'Tạo danh mục sản phẩm mới',
        save_error: 'Không thể lưu danh mục. Vui lòng thử lại.',
      };
